import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/home/infop.png'
import _imports_1 from '@/assets/images/home/down.svg'
import _imports_2 from '@/assets/images/home/sortInfo.png'


const _withScopeId = n => (_pushScopeId("data-v-1b05aa60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bulk-trading" }
const _hoisted_2 = { class: "bulk-content" }
const _hoisted_3 = { class: "trading" }
const _hoisted_4 = { class: "trading-title" }
const _hoisted_5 = { class: "trading-operation" }
const _hoisted_6 = { class: "operation-name" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "类型", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "股票代码", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "最新价", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "数量", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "金额", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "最大可买", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "最大可卖", -1))
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "盘前盘后", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, " 允许: 订单将在盘前盘后、盘中时段进行对盘撮合，盘前盘后未成交订单会自动转入盘中时段。 "),
  /*#__PURE__*/_createElementVNode("p", null, "不允许: 订单仅在盘中时段进行对盘撮合。")
], -1))
const _hoisted_20 = { class: "operation-fn" }
const _hoisted_21 = {
  key: 0,
  class: "fn-arrow"
}
const _hoisted_22 = { class: "margin20" }
const _hoisted_23 = { class: "margin20" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15px",
  viewBox: "0 0 1024 1024",
  "data-v-394d1fd8": ""
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M104.704 338.752a64 64 0 0 1 90.496 0l316.8 316.8 316.8-316.8a64 64 0 0 1 90.496 90.496L557.248 791.296a64 64 0 0 1-90.496 0L104.704 429.248a64 64 0 0 1 0-90.496z"
  })
], -1))
const _hoisted_25 = { class: "cal-font" }
const _hoisted_26 = ["src"]
const _hoisted_27 = ["src"]
const _hoisted_28 = {
  key: 1,
  class: "up-down-diamond",
  src: _imports_1,
  alt: ""
}
const _hoisted_29 = ["src"]
const _hoisted_30 = {
  key: 5,
  class: "custom-extended-quotation"
}
const _hoisted_31 = {
  key: 2,
  class: "add-num"
}
const _hoisted_32 = { class: "add-sub" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-jianhao" }, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-plus" }, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "add-num" }
const _hoisted_38 = { class: "add-sub" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-jianhao" }, null, -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = ["disabled"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-plus" }, null, -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { class: "fn-number" }
const _hoisted_45 = { class: "fn-number" }
const _hoisted_46 = { class: "fn-number" }
const _hoisted_47 = { key: 3 }
const _hoisted_48 = {
  key: 0,
  class: "pre-market"
}
const _hoisted_49 = ["src"]
const _hoisted_50 = { key: 4 }
const _hoisted_51 = {
  key: 0,
  class: "pre-market"
}
const _hoisted_52 = ["src"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "允许", -1))
const _hoisted_54 = ["src"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "不允许", -1))
const _hoisted_56 = { class: "five-list" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = { style: {"color":"#a79a28"} }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { style: {"color":"#386aff"} }
const _hoisted_61 = {
  key: 0,
  class: "operation-list five-list-td"
}
const _hoisted_62 = { class: "list-td-le" }
const _hoisted_63 = { class: "open-data" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "今开", -1))
const _hoisted_65 = { class: "open-data" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "换手", -1))
const _hoisted_67 = { class: "list-td-rg" }
const _hoisted_68 = { class: "open-data" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "最低", -1))
const _hoisted_70 = { class: "open-data" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "最高", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "trading-show" }, null, -1))
const _hoisted_73 = { class: "account" }
const _hoisted_74 = { class: "account-title" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "account-span" }, "请勾选客户账号", -1))
const _hoisted_76 = { class: "account-btn" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-info" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" 账户排序顺序即为下单顺序 ")
], -1))
const _hoisted_78 = {
  key: 1,
  class: "trading-btn"
}
const _hoisted_79 = { key: 1 }
const _hoisted_80 = {
  key: 2,
  class: "loading-input"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tipcom = _resolveComponent("tipcom")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_FargoTable = _resolveComponent("FargoTable")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_dropdown = _resolveComponent("dropdown")!
  const _component_dropdownInput = _resolveComponent("dropdownInput")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_prompt = _resolveComponent("prompt")!
  const _component_confirmPopup = _resolveComponent("confirmPopup")!
  const _component_timeoutDialog = _resolveComponent("timeoutDialog")!
  const _component_success = _resolveComponent("success")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.currentDisabled ? '改单' : '请选择要交易的股票'), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, [
              _hoisted_7,
              _createVNode(_component_el_popover, {
                placement: "right",
                width: 280,
                trigger: "hover",
                content: "允许: 订单将在盘前盘后、盘中时段进行对盘撮合，盘前盘后未成交订单会自动转入盘中时段。不允许: 订单仅在盘中时段进行对盘撮合。"
              }, {
                reference: _withCtx(() => [
                  _hoisted_8
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_tipcom, {
                      currentItem: _ctx.currentItem.valueOf
                    }, null, 8, ["currentItem"])
                  ])
                ]),
                _: 1
              })
            ]),
            _hoisted_9,
            _hoisted_10,
            (_ctx.marketFlag)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "价格"))
              : _createCommentVNode("", true),
            _hoisted_12,
            _hoisted_13,
            _hoisted_14,
            _hoisted_15,
            (_ctx.obj.icon === 'US')
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_el_popover, {
                    placement: "top-start",
                    title: "盘前盘后",
                    width: 280,
                    trigger: "hover",
                    content: "允许: 订单将在盘前盘后、盘中时段进行对盘撮合，盘前盘后未成交订单会自动转入盘中时段。不允许: 订单仅在盘中时段进行对盘撮合。"
                  }, {
                    reference: _withCtx(() => [
                      _hoisted_18
                    ]),
                    default: _withCtx(() => [
                      _hoisted_19
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_20, [
            (_ctx.currentDisabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.currentItem.label), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "fn-arrow",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeType && _ctx.changeType(...args)))
                }, [
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.currentItem.label), 1),
                  _hoisted_24
                ])),
            _createElementVNode("div", null, [
              _createElementVNode("div", null, [
                (!_ctx.obj.label)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 0,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.stock) = $event)),
                      onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.inputStock && _ctx.inputStock(...args))),
                      class: "input",
                      type: "text",
                      placeholder: "请输入股票名称/代码"
                    }, null, 544)), [
                      [_vModelText, _ctx.stock]
                    ])
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass({ 'koa-font': _ctx.obj?.label?.length > 61 })
                }, [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.obj.label) + " " + _toDisplayString(_ctx.obj.code), 1)
                ], 2),
                (_ctx.obj.label)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass({
                    shadow: _ctx.obj.icon === 'HK',
                    'shadow-us': _ctx.obj.icon === 'US',
                    'shadow-a': _ctx.obj.icon === 'SZ' || _ctx.obj.icon === 'SH'
                  })
                    }, _toDisplayString(_ctx.obj.icon), 3))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.stock && !_ctx.currentDisabled)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.close,
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearInput && _ctx.clearInput(...args))),
                    style: {"width":"10px","height":"10px","cursor":"pointer","margin":"0 17px","z-index":"200"},
                    alt: ""
                  }, null, 8, _hoisted_26))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.computedChangeColor)
              }, _toDisplayString(_ctx.quotDetail.price || '- -'), 3),
              (_ctx.obj.label && _ctx.changeFlagNum === 2)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "up-down-diamond",
                    src: _ctx.up,
                    alt: ""
                  }, null, 8, _hoisted_27))
                : _createCommentVNode("", true),
              (_ctx.obj.label && _ctx.changeFlagNum === 0)
                ? (_openBlock(), _createElementBlock("img", _hoisted_28))
                : _createCommentVNode("", true),
              (_ctx.obj.label && _ctx.changeFlagNum === 1)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 2,
                    class: "up-down-diamond",
                    src: _ctx.diamond,
                    alt: ""
                  }, null, 8, _hoisted_29))
                : _createCommentVNode("", true),
              (_ctx.obj.label)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 3,
                    style: {"margin-right":"10px"},
                    class: _normalizeClass(_ctx.computedChangeColor)
                  }, _toDisplayString(_ctx.quotDetail.change
                    ? _ctx.changeFlagNum === 2
                      ? '+' + _ctx.quotDetail.change
                      : _ctx.quotDetail.change
                    : '' || '- -'), 3))
                : _createCommentVNode("", true),
              (_ctx.obj.label)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 4,
                    class: _normalizeClass(_ctx.computedChangeColor)
                  }, _toDisplayString(_ctx.computedRiseFall || '- -'), 3))
                : _createCommentVNode("", true),
              (_ctx.showExtendedQuotationText && ['HK', 'US'].includes(_ctx.obj.icon))
                ? (_openBlock(), _createElementBlock("div", _hoisted_30))
                : _createCommentVNode("", true)
            ]),
            (_ctx.marketFlag)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("span", {
                      class: "input-add input-sub",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handlerClick('subPrice')))
                    }, _hoisted_34),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.price) = $event)),
                      ref: "refPrice",
                      class: "input input1",
                      type: "text",
                      onKeydown: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.keydown && _ctx.keydown(...args))),
                      onBlur: _cache[7] || (_cache[7] = ($event: any) => (
                    _ctx.price =
                      _ctx.obj.icon === 'SH' || _ctx.obj.icon === 'SZ'
                        ? _ctx.numFormat(_ctx.price, 2).replace(/,/g, '')
                        : _ctx.numFormat(_ctx.price, 3).replace(/,/g, '')
                  )),
                      placeholder: "请输入价格"
                    }, null, 544), [
                      [_vModelText, _ctx.price]
                    ]),
                    _createElementVNode("span", {
                      class: "input-add",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handlerClick('addPrice')))
                    }, _hoisted_36)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("span", {
                  class: "input-add input-sub",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handlerClick('subNum')))
                }, _hoisted_40),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.num) = $event)),
                  ref: "inputNumRef",
                  class: "input input1",
                  placeholder: "请输入数量",
                  disabled: _ctx.allocationIndex === '2',
                  autocompleted: "off",
                  autocomplete: "new-password",
                  onInput: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.inputNum && _ctx.inputNum(...args)))
                }, null, 40, _hoisted_41), [
                  [_vModelText, _ctx.num]
                ]),
                _createElementVNode("span", {
                  class: "input-add",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handlerClick('addNum')))
                }, _hoisted_43)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.amountComputed), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.maxBuy), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.maxSell), 1)
            ]),
            (_ctx.obj.icon === 'US' && _ctx.currentDisabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  (_ctx.currentDisabled)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        _createElementVNode("img", {
                          src: _ctx.ok1,
                          alt: "",
                          style: {"display":"inline-block","margin-right":"15px","width":"20px","height":"20px"}
                        }, null, 8, _hoisted_49),
                        _createElementVNode("span", null, _toDisplayString(_ctx.preMarketFlag ? '允许' : '不允许'), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.obj.icon === 'US' && !_ctx.currentDisabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  (!_ctx.currentDisabled)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        _createElementVNode("div", {
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.changePreMkt(true))),
                          style: {"margin-right":"42px"}
                        }, [
                          _createElementVNode("img", {
                            src: _ctx.preMarketFlag ? _ctx.ok1 : _ctx.ok2,
                            alt: ""
                          }, null, 8, _hoisted_52),
                          _hoisted_53
                        ]),
                        _createElementVNode("div", {
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.changePreMkt(false)))
                        }, [
                          _createElementVNode("img", {
                            src: _ctx.preMarketFlag ? _ctx.ok2 : _ctx.ok1,
                            alt: ""
                          }, null, 8, _hoisted_54),
                          _hoisted_55
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", {
            class: _normalizeClass(["operation-list", {
              'min-hei': _ctx.obj.icon === 'US'
            }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.b5List, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "ripple",
                onClick: ($event: any) => (_ctx.selectSeller(item))
              }, [
                _createElementVNode("span", _hoisted_58, _toDisplayString(item.label), 1),
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.autoColor(item.price))
                }, _toDisplayString(item.price), 3),
                _createElementVNode("span", null, _toDisplayString(_ctx.numFormatK(item.qty)), 1)
              ], 8, _hoisted_57))
            }), 128))
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["operation-list sell-flex", {
              'min-hei': _ctx.obj.icon === 'US'
            }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.s5List, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "ripple",
                onClick: ($event: any) => (_ctx.selectSeller(item))
              }, [
                _createElementVNode("span", _hoisted_60, _toDisplayString(item.label), 1),
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.autoColor(item.price))
                }, _toDisplayString(item.price), 3),
                _createElementVNode("span", null, _toDisplayString(_ctx.numFormatK(item.qty)), 1)
              ], 8, _hoisted_59))
            }), 128))
          ], 2)
        ]),
        (_ctx.showUS)
          ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _hoisted_64,
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.autoColor(_ctx.quotDetail.open))
                  }, _toDisplayString(_ctx.quotDetail.open === '' ? '--' : _ctx.quotDetail.open), 3)
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _hoisted_66,
                  _createElementVNode("span", null, _toDisplayString((_ctx.quotDetail.turnRate
                  ? new _ctx.Decimal((_ctx.quotDetail.turnRate * 10000) / 100).toFixed(
                      2,
                      _ctx.Decimal.ROUND_DOWN
                    ) + '%'
                  : '--') === '0.00%'
                  ? '--'
                  : _ctx.quotDetail.turnRate
                  ? new _ctx.Decimal((_ctx.quotDetail.turnRate * 10000) / 100).toFixed(
                      2,
                      _ctx.Decimal.ROUND_DOWN
                    ) + '%'
                  : '--'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, [
                  _hoisted_69,
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.autoColor(_ctx.quotDetail.low))
                  }, _toDisplayString(_ctx.quotDetail.low), 3)
                ]),
                _createElementVNode("div", _hoisted_70, [
                  _hoisted_71,
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.autoColor(_ctx.quotDetail.high))
                  }, _toDisplayString(_ctx.quotDetail.high), 3)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_72
      ]),
      _createElementVNode("div", _hoisted_73, [
        _createElementVNode("div", _hoisted_74, [
          _hoisted_75,
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("span", {
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.allocation('0'))),
              class: _normalizeClass(_ctx.allocationIndex === '0' ? '' : 'span')
            }, "平均分配", 2),
            _createElementVNode("span", {
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.allocation('1'))),
              class: _normalizeClass(_ctx.allocationIndex === '1' ? '' : 'span')
            }, "按购买力分配", 2),
            _createElementVNode("span", {
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.allocation('2'))),
              class: _normalizeClass(_ctx.allocationIndex === '2' ? '' : 'span')
            }, "自定义分配", 2)
          ])
        ]),
        _createVNode(_component_FargoTable, {
          "table-loading": _ctx.tableLoading,
          list: _ctx.tableData,
          "onUpdate:list": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.tableData) = $event)),
          "t-header-list": _ctx.tHeaderList,
          stripe: false,
          draggableTable: true,
          buyHand: _ctx.buyHand,
          buyPrice: _ctx.price,
          onChangeSelect: _ctx.changeSelect,
          onChange: _ctx.change,
          onCheckAll: _ctx.checkAll,
          height: _ctx.height,
          onSortTable: _ctx.sortTable,
          isUpdate: _ctx.currentDisabled
        }, null, 8, ["table-loading", "list", "t-header-list", "buyHand", "buyPrice", "onChangeSelect", "onChange", "onCheckAll", "height", "onSortTable", "isUpdate"]),
        _hoisted_77,
        (!_ctx.unlockFlag)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              class: "unlock-button",
              type: "info"
            }, {
              default: _withCtx(() => [
                _createTextVNode("解锁交易")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.unlockFlag)
          ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
              (!_ctx.currentDisabled)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "orange",
                    onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.bulkBuy && _ctx.bulkBuy(...args)))
                  }, "批量买入"))
                : _createCommentVNode("", true),
              (_ctx.currentDisabled)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    style: _normalizeStyle(
              _ctx.sellDirection === '买入'
                ? 'background-color:#A79A28'
                : 'background-color:#386aff'
            ),
                    onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.confirmChangeOrder && _ctx.confirmChangeOrder(...args)))
                  }, "确认改单" + _toDisplayString(_ctx.sellDirection), 5))
                : _createCommentVNode("", true),
              (!_ctx.currentDisabled)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 2,
                    onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.batchSell && _ctx.batchSell(...args))),
                    class: "blue"
                  }, "批量卖出"))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.typeFlag)
      ? (_openBlock(), _createBlock(_component_dropdown, {
          key: 0,
          onChangeItem: _ctx.changeItem,
          changeItemIndex: _ctx.changeItemIndex,
          list: _ctx.list
        }, null, 8, ["onChangeItem", "changeItemIndex", "list"]))
      : _createCommentVNode("", true),
    (!_ctx.inputLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
          (_ctx.inputFlag)
            ? (_openBlock(), _createBlock(_component_dropdownInput, {
                key: 0,
                onSelectItem: _ctx.selectItem,
                inputFlag: _ctx.inputFlag,
                "onUpdate:inputFlag": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.inputFlag) = $event)),
                stock: _ctx.stock,
                "onUpdate:stock": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.stock) = $event)),
                associateList: _ctx.associateList
              }, null, 8, ["onSelectItem", "inputFlag", "stock", "associateList"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.inputLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
          (_ctx.inputLoading)
            ? (_openBlock(), _createBlock(_component_el_skeleton, {
                key: 0,
                rows: 3,
                animated: ""
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_prompt, {
      title: _ctx.promptTitle,
      onBrokenStock: _ctx.brokenStock,
      dialogVisible: _ctx.dialogVisible,
      "onUpdate:dialogVisible": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.dialogVisible) = $event))
    }, null, 8, ["title", "onBrokenStock", "dialogVisible"]),
    _createVNode(_component_confirmPopup, {
      title: _ctx.buyTitle,
      buyLoading: _ctx.buyLoading,
      onBuyNow: _ctx.buyNow,
      dialogVisible: _ctx.confirmPopupFlag,
      "onUpdate:dialogVisible": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.confirmPopupFlag) = $event)),
      tradingData: _ctx.tradingData,
      tradingObj: _ctx.tradingObj,
      totalAmount: _ctx.amountComputed,
      price: _ctx.price
    }, null, 8, ["title", "buyLoading", "onBuyNow", "dialogVisible", "tradingData", "tradingObj", "totalAmount", "price"]),
    _createVNode(_component_timeoutDialog, {
      timeoutDialogStatus: _ctx.timeoutDialogFlag,
      "onUpdate:timeoutDialogStatus": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.timeoutDialogFlag) = $event))
    }, null, 8, ["timeoutDialogStatus"]),
    _createVNode(_component_success, {
      loading: _ctx.updateLoading,
      onConfirm: _ctx.confirm,
      dialogVisible: _ctx.updateFlag,
      "onUpdate:dialogVisible": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.updateFlag) = $event)),
      tradingData: _ctx.updateData
    }, null, 8, ["loading", "onConfirm", "dialogVisible", "tradingData"])
  ]))
}